"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _excluded = ["className", "theme", "testId", "children", "options", "triggerOn", "popupPosition", "anchorPosition", "appendToBody", "refCallback"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  children: null,
  options: [],
  triggerOn: ['hover', 'click'],
  popupPosition: 'tl',
  anchorPosition: 'bl',
  appendToBody: true,
  theme: {}
};

/**
 * The pop-up menu that provides shortcuts for actions
 */
var ContextMenu = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ContextMenu, _React$Component);
  function ContextMenu(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ContextMenu);
    _this = _callSuper(this, ContextMenu, [props]);
    _this.state = {
      isSiblingMenuOpen: false
    };
    _this.handleToggleSiblingMenu = _this.handleToggleSiblingMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClickOutside = _this.handleClickOutside.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderOptions = _this.renderOptions.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleOnClose = _this.handleOnClose.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleOnOpen = _this.handleOnOpen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setFirstOptionRef = _this.setFirstOptionRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.firstRender = false;
    return _this;
  }
  (0, _createClass2["default"])(ContextMenu, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleClickOutside, false);
    }
  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(e) {
      if (e.target !== this.siblingMenuToggleRef && !this.siblingMenuToggleRef.contains(e.target)) {
        this.handleToggleSiblingMenu();
      }
    }
  }, {
    key: "handleToggleSiblingMenu",
    value: function handleToggleSiblingMenu() {
      if (this.props.triggerOn.indexOf('click') !== -1) {
        var isSiblingMenuOpen = !this.state.isSiblingMenuOpen;
        this.setState({
          isSiblingMenuOpen: isSiblingMenuOpen
        });
        if (isSiblingMenuOpen) {
          document.body.addEventListener('click', this.handleClickOutside, false);
        } else {
          document.body.removeEventListener('click', this.handleClickOutside, false);
        }
      }
    }
  }, {
    key: "handleOnClose",
    value: function handleOnClose(e) {
      if (this.props.onClose) {
        this.props.onClose(e);
      }
    }
  }, {
    key: "handleOnOpen",
    value: function handleOnOpen() {
      this.firstRender = true;
    }
  }, {
    key: "setFirstOptionRef",
    value: function setFirstOptionRef(ref) {
      if (this.firstRender && this.props.triggerOn.includes('click')) {
        this.firstOptionRef = ref;
        this.firstOptionRef.focus();
        this.firstRender = false;
      }
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options) {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        theme = _this$props.theme,
        testId = _this$props.testId;
      var classes = (0, _classnames["default"])(theme.menu, className);
      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: classes
      }, options.map(function (option, index) {
        var testIdProp = testId && "".concat(testId, "-").concat(option.label ? option.label.replace(/\s+/g, '-').toLowerCase() : "option-".concat(index));
        var optionClassName = (0, _classnames["default"])(theme.button, option.disabled && theme.disabled);
        var optionAction = function optionAction() {
          option.onClick();
          if (!_this2.props.appendToBody) {
            _this2.setState({
              isSiblingMenuOpen: false
            });
          }
        };
        var separator = /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.separator
        });
        var button = option.href ? /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
          ref: function ref(_ref) {
            if (index === 0) {
              _this2.setFirstOptionRef(_ref);
            }
          },
          className: optionClassName,
          "data-test-id": testIdProp
        }, option, {
          href: !option.disabled ? option.href : undefined
        }), option.label) : /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
          ref: function ref(_ref2) {
            if (index === 0) {
              _this2.setFirstOptionRef(_ref2);
            }
          },
          className: optionClassName,
          "data-test-id": testIdProp
        }, option, {
          onClick: !option.disabled ? optionAction : undefined
        }), option.label);
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: theme.option,
          key: index
        }, option.separator ? separator : button);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        className = _this$props2.className,
        theme = _this$props2.theme,
        testId = _this$props2.testId,
        children = _this$props2.children,
        options = _this$props2.options,
        triggerOn = _this$props2.triggerOn,
        popupPosition = _this$props2.popupPosition,
        anchorPosition = _this$props2.anchorPosition,
        appendToBody = _this$props2.appendToBody,
        refCallback = _this$props2.refCallback,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var optionsContent = this.renderOptions(options);
      var trigger = /*#__PURE__*/_react["default"].createElement("div", {
        "data-test-id": testId && "content-".concat(testId)
      }, children);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(className, theme.contextMenu),
        "data-test-id": testId,
        "data-anypoint-component": ContextMenu.displayName,
        ref: function ref(node) {
          if (refCallback && typeof refCallback === 'function') {
            refCallback(node);
          }
        }
      }, appendToBody ? /*#__PURE__*/_react["default"].createElement(_Popover["default"], (0, _extends2["default"])({
        theme: (0, _typeof2["default"])(theme.Popover) === 'object' ? theme.Popover : undefined,
        content: optionsContent,
        closeOnClickInside: true,
        triggerOn: triggerOn,
        popupPosition: popupPosition,
        anchorPosition: anchorPosition,
        onClose: this.handleOnClose,
        onOpen: this.handleOnOpen,
        triggerComponent: trigger
      }, props)) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _classnames["default"].apply(void 0, [theme.menuSibling].concat((0, _toConsumableArray2["default"])(popupPosition.split('').map(function (p, i) {
          return theme["menu-sibling-popup-position-".concat(p, "-").concat(i)];
        })), (0, _toConsumableArray2["default"])(anchorPosition.split('').map(function (p, i) {
          return theme["menu-sibling-anchor-position-".concat(p, "-").concat(i)];
        })), [this.state.isSiblingMenuOpen ? theme['menu-sibling-state-is-open'] : null], (0, _toConsumableArray2["default"])(triggerOn.map(function (h) {
          return theme["menu-sibling-handle-".concat(h)];
        })))),
        "data-test-id": testId && "".concat(testId, "-menu-sibling")
      }, /*#__PURE__*/_react["default"].createElement("button", {
        className: theme['menu-sibling-toggle'],
        onClick: this.handleToggleSiblingMenu,
        ref: function ref(r) {
          return _this3.siblingMenuToggleRef = r;
        },
        "data-test-id": testId && "".concat(testId, "-menu-sibling-toggle")
      }, trigger), /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['menu-sibling-options'],
        "data-test-id": testId && "".concat(testId, "-menu-sibling-options")
      }, optionsContent)));
    }
  }]);
  return ContextMenu;
}(_react["default"].Component);
(0, _defineProperty2["default"])(ContextMenu, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(ContextMenu, "displayName", 'ContextMenu');
//# sourceMappingURL=ContextMenu.js.map